import { useUserStore } from "../../store";
import energyIcon from "../../assets/low-battery.png";
import {
  LottiePlayer,
  Progressbar,
} from '../../components';
import { MAX_ENERGY_BY_LEVEL } from '../../config';
import { Round } from "../../utils/math";
import styled from "styled-components";

export const EnergyBar = () => {
  const userInfo = useUserStore((state) => state.user);

  if (typeof userInfo.energy !== 'number') {
    return null;
  }

  return (
    <Container>
      <EnergyIndicators>
        <EnergyIcon>
          {userInfo.energy === 0 ? (
            <img src={energyIcon} alt="Energy" />
          ) : (
            <LottiePlayer
              lottieUrl="https://cdn.notwise.co/lottie/nrg.lottie"
              isLoop={false}
              preloaderStyle="round"
            />
          )}
        </EnergyIcon>
        <EnergyLabel>
          <span style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
            {userInfo.energy}
          </span>
          <br />
          <span style={{ opacity: 0.7 }}>
            / {MAX_ENERGY_BY_LEVEL[userInfo.level]}
          </span>
        </EnergyLabel>
      </EnergyIndicators>
      <ProgressBarIndicator>
        <Progressbar
          blurred
          winking={false}
          barcolor="bg-gradient-to-r from-[#FF6F41] via-[#FFAD42] to-[#FFE34F]"
          ht="min-h-3"
          percent="w"
          spark={false}
          value={userInfo.energy}
          maxvalue={MAX_ENERGY_BY_LEVEL[userInfo.level]}
          customStyle={{ width: `${Round(userInfo.energy / (MAX_ENERGY_BY_LEVEL[userInfo.level]/100), 1)}%` }}
        />
      </ProgressBarIndicator>
    </Container>
  );
};

const EnergyLabel = styled.div`
  color: #ffffff;
  font-weight: 500;
  font-size: 0.825rem;
  line-height: 1.5rem;
  margin-left: 0.25rem;
  white-space: nowrap;
  min-width: 50px;
`;

const EnergyIcon = styled.div`
  width: 32px;
  height: 32px;
`;

const ProgressBarIndicator = styled.div`
  flex: 1;
`;

const EnergyIndicators = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  padding-right: 1rem;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 1rem;
  padding: 0 1.25rem;
`;
